<script setup lang="ts">
import {
	ComboboxContent,
	useForwardPropsEmits,
	type ComboboxContentEmits,
	type ComboboxContentProps,
} from "reka-ui";

const props = defineProps<ComboboxContentProps>();
const emits = defineEmits<ComboboxContentEmits>();

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
	<ComboboxContent v-bind="forwarded">
		<slot />
	</ComboboxContent>
</template>
